import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
      <div className={style.container}>
        <p className={style.titulo}>{t('Products.SyncFlow.FirstPart.title')}&nbsp;{t('Products.SyncFlow.FirstPart.title2')}</p>
        <div className={style.divContainer}>
          <div className={style.divIzq}>
            <p className={style.text}>{t('Products.SyncFlow.FirstPart.text')}</p>
            <p className={style.text}>{t('Products.SyncFlow.FirstPart.text2')}</p>
            <p className={style.title}>{t('Products.SyncFlow.FirstPart.title3')}</p>
            <div className={style.separador}></div>
            <p className={style.text}>{t('Products.SyncFlow.FirstPart.text5')}</p>
          </div>
          <div className={style.divDer}>
            <p className={style.title}>{t('Products.SyncFlow.FirstPart.title4')}</p>
            <div className={style.separador}></div>
            <ul className={style.ul}>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li2')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li3')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li4')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li5')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li6')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li7')}</li>
              <li className={style.li}>{t('Products.SyncFlow.FirstPart.li8')}</li>
            </ul>
          </div>
        </div>
      </div>
    )
}

export default PrimeraParte